export enum ESOCIAL_VALIDATION_STATUS {
  ACCEPTED = 'ACCEPTED',
  IN_PROGRESS = 'IN_PROGRESS',
  DENIED = 'DENIED',
  ERROR = 'ERROR',
  LOAD_PAYROLL_DATA_ERROR = 'LOAD_PAYROLL_DATA_ERROR',
  LOAD_REGISTRATION_DATA_ERROR = 'LOAD_REGISTRATION_DATA_ERROR',
  LOAD_LABOR_DATA_ERROR = 'LOAD_LABOR_DATA_ERROR',
}
